import { Toaster } from "@blueprintjs/core";
export default Toaster.create()


// WEBPACK FOOTER //
// ./src/util/toaster.js